<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

        <div class="rwt-split-area rn-section-gap">
          <div class="wrapper">
            <div class="row">
              <div class="col-lg-12 mb--40">
                <SectionTitle
                    subtitle="YAO XIE GONG MAO"
                    text-align="center"
                    title="公司简介"
                    data-aos="fade-up"
                />
              </div>
            </div>
            <AboutCompanySection :split-style="4" :split-data="splitThreeData"/>
          </div>
        </div>



  </Layout>
</template>

<script>


import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import Layout from "../../components/common/Layout";
import AboutCompanySection from "@/views/about-us/AboutCompanySection";
export default {
  name: "AboutCompany",
  components: {AboutCompanySection,SectionTitle,Layout},
  data(){
    return{
      splitThreeData: {
        image: 'split-03.jpg',
        title: '',
        description: ``,
      },
      company:{}

    }
  },
  created() {
    this.getCompany();
  },
  methods:{
    getCompany(){
      this.getRequest("/system/web/getCompany").then(resp=>{

        this.splitThreeData.title = resp.data.title;
        this.splitThreeData.description = resp.data.content;
      })
    }
  }
}
</script>
